


const predictions = {
  predictions: {
    title: "AI Predictions",
    subtitle: "Today's Football Predictions",
    description: "Powered by advanced AI analysis",
    matchOf: "Match of",
    probability: "Probability",
    confidence: "Confidence",
    prediction: "Prediction",
    odds: "Odds",
    league: "League",
    date: "Date",
    time: "Time",
    status: "Status",
    home: "Home",
    away: "Away",
    draw: "Draw",
    over: "Over",
    under: "Under",
    btts: "Both Teams to Score",
    cleanSheet: "Clean Sheet",
    loading: "Loading predictions...",
    noData: "No predictions available",
    error: "Error loading predictions",
    tryAgain: "Try again",
    viewDetails: "View Details",
    addToTicket: "Add to Ticket",
    removeFromTicket: "Remove from Ticket",
    inTicket: "In Ticket",
    filterByLeague: "Filter by League",
    allLeagues: "All Leagues",
    sortBy: "Sort by",
    highestProbability: "Highest Probability",
    lowestOdds: "Lowest Odds",
    earliestMatch: "Earliest Match",
    refreshPredictions: "Refresh Predictions",
    lastUpdated: "Last updated",
    matches: "matches",
    match: "match",
    all: "All Predictions",
    value: "Value Bets",
    high: "High Probability",
    filters: "Filters",
    retry: "Retry",
    refreshing: "Refreshing predictions...",
    noFound: "No predictions found for the selected filters",
    valueBet: "Value Bet",
    noValue: "No Value",
    notAvailable: "Predictions not available",
    noDataDescription: "No prediction data available for this match at the moment.",
    
    categories: {
      match1x2: "Match 1X2",
      doubleChance: "Double Chance",
      match1x2HalfTime: "Match 1X2 Half-Time",
      doubleChanceHalfTime: "Double Chance Half-Time",
      halfTimeFullTime: "Match Half-Time/Full-Time",
      goalsOverUnder: "Goals Over/Under",
      goalsOverUnderHalfTime: "Goals Over/Under Half-Time",
      homeGoalsOverUnder: "Home Goals Over/Under",
      awayGoalsOverUnder: "Away Goals Over/Under",
      cornersOverUnder: "Corners Over/Under",
      bothTeamsToScore: "Both Teams to Score",
      others: "Others"
    },

    table: {
      prediction: "Prediction",
      odd: "Odd",
      probability: "Probability",
      prob: "Prob",
      value: "Value",
      ticket: "Ticket"
    },

    recommendations: {
      title: "Bet Recommendations",
      withOdd: "with odd",
      probability: "probability",
      add: "Add",
      noHighConfidence: "There are no betting recommendations with high confidence for this match."
    }
  }
};

export default predictions;


